module.exports = __webpack_public_path__ + "img/icon15.90eae2db.svg";